import { Routes } from '@angular/router';
import { canActivateApp } from './app.activate.guard';
import { canMatchRestrictedArea } from './features/restricted-area.match.guard';
import { MainLayoutComponent } from './layouts/main-layout.component';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'quotations-sign',
    loadComponent: () =>
      import('./features/biddings/components/libs/sign-workflow/quotation-sign-workflow.component').then(
        (m) => m.QuotationSignWorkflowComponent
      ),
  },
  {
    path: '',
    canActivate: [canActivateApp],
    children: [
      {
        path: 'auth',
        loadChildren: () => import('./features/auth/auth.routes').then((r) => r.routes),
      },
      {
        path: '',
        component: MainLayoutComponent,
        canMatch: [canMatchRestrictedArea],
        children: [
          {
            path: 'dashboard',
            loadChildren: () => import('./features/dashboard/dashboard.routes').then((r) => r.routes),
          },
          {
            path: 'rules',
            loadChildren: () => import('./features/rules/rules.routes').then((r) => r.routes),
          },
          { path: 'contacts', loadChildren: () => import('./features/contacts/contacts.routes').then((r) => r.routes) },
          {
            path: 'real-estates',
            loadChildren: () => import('./features/real-estates/real-estates.routes').then((r) => r.routes),
          },
          {
            path: 'leads',
            loadChildren: () => import('./features/leads/leads.routes').then((r) => r.routes),
          },
          {
            path: 'scoutings',
            loadChildren: () => import('./features/scoutings/scoutings.routes').then((r) => r.routes),
          },
          {
            path: 'scheduler',
            loadChildren: () => import('./features/scheduler/scheduler.routes').then((r) => r.routes),
          },
          {
            path: 'profile',
            loadChildren: () => import('./features/profile/profile.routes').then((r) => r.routes),
          },
          {
            path: 'membership',
            loadChildren: () => import('./features/membership/membership.routes').then((r) => r.routes),
          },
          {
            path: 'todo',
            loadChildren: () => import('./features/todo/todo.routes').then((r) => r.routes),
          },
          {
            path: 'suppliers',
            loadChildren: () => import('./features/suppliers/suppliers.routes').then((r) => r.routes),
          },
          {
            path: 'owner-company',
            loadChildren: () => import('./features/owner-company/owner-company.routes').then((r) => r.routes),
          },
          {
            path: 'employees',
            loadChildren: () => import('./features/employees/employees.routes').then((r) => r.routes),
          },
          {
            path: 'sales',
            loadChildren: () => import('./features/sales/sales.routes').then((r) => r.routes),
          },
          {
            path: 'biddings',
            loadChildren: () => import('./features/biddings/biddings.routes').then((r) => r.routes),
          },
        ],
      },
    ],
  },
];
